var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Checked .cls-1 {\n        fill: #33bc12;\n      }\n\n      #Checked .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-782.604 -448.22)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(782.604 448.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_598",
    "data-name": "Pfad 598",
    className: "cls-2",
    d: "M804.466,459.587l-.7,1.279a6.869,6.869,0,0,1,.443,2.39,6.973,6.973,0,1,1-3.793-6.183l.541-1.022a8.208,8.208,0,1,0,3.507,3.535Z",
    transform: "translate(-1.499 -1.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_599",
    "data-name": "Pfad 599",
    className: "cls-2",
    d: "M809.314,474.116a1.157,1.157,0,1,0-1.636,1.635l3.827,3.828a1.156,1.156,0,0,0,1.635-1.635Z",
    transform: "translate(-5.662 -5.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_600",
    "data-name": "Pfad 600",
    className: "cls-2",
    d: "M794.8,459.852a1.157,1.157,0,1,0-1.735,1.53L798.027,467a1.157,1.157,0,0,0,.867.391,1.275,1.275,0,0,0,.133-.007,1.16,1.16,0,0,0,.886-.6l5.618-10.465a1.157,1.157,0,0,0-2.038-1.095l-4.832,9Z",
    transform: "translate(-2.33 -1.464)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.c435ba457b8ab631cdee69e1eb7b6434.svg";
export { ForwardRef as ReactComponent };